import * as React from "react";

const SliderArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    fill="none"
    viewBox="0 0 44 44"
  >
    <g filter="url(#filter0_d_2866_37977)">
      <path
        fill="#fff"
        d="M31 22a1 1 0 1 0 0-2zm-19.207-1.707a1 1 0 0 0 0 1.414l6.364 6.364a1 1 0 0 0 1.414-1.414L13.914 21l5.657-5.657a1 1 0 0 0-1.414-1.414zM31 20H12.5v2H31z"
      ></path>
      <circle
        cx="22"
        cy="21"
        r="19"
        stroke="#fff"
        strokeWidth="2"
        transform="rotate(180 22 21)"
      ></circle>
    </g>
    <defs>
      <filter
        id="filter0_d_2866_37977"
        width="44"
        height="44"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="1"></feOffset>
        <feGaussianBlur stdDeviation="1"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2866_37977"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_2866_37977"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);

export default SliderArrowLeft;
